import { render } from "./NewTestItem.vue?vue&type=template&id=75cebdd0&scoped=true"
import script from "./NewTestItem.vue?vue&type=script&lang=js"
export * from "./NewTestItem.vue?vue&type=script&lang=js"

import "./NewTestItem.vue?vue&type=style&index=0&id=75cebdd0&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cebdd0"]])

export default __exports__